module.exports = __webpack_public_path__ + "img/partner27.881adcba.png";